import Shipment from 'interfaces/PmParcel';
import { Configs } from 'interfaces/WidgetConfigs.interface';
import EVENT_PHASE_KEY from '@pperform/pp-constants/eventPhase.constants';
import EVENT_PHASE_ANALYTICS from '@pperform/pp-constants/eventAnalytics.constants';

// reference: https://parcelperform.slack.com/archives/C04EPK46J0P/p1672200442378519
export const isShipmentReturnable = (
  shipment: Shipment,
  config: Configs,
): boolean => {
  // user cannot return shipment if shipment does not have line item
  const shipmentHasLineItems = shipment.frontEndAdditionalData?.hasLineItems;
  if (!shipmentHasLineItems) return false;

  // user cannot return shipment if it's not in delivery phase
  const shipmentLastEvent = shipment.parcel?.lastEvent?.eventTypeMasterData;
  const eventPhaseKey = shipmentLastEvent?.phaseKey;
  const eventPhaseAnalytics = shipmentLastEvent?.analytics;
  const parcelIsInDelivery =
    eventPhaseKey === EVENT_PHASE_KEY.delivery &&
    eventPhaseAnalytics === EVENT_PHASE_ANALYTICS.regular;
  if (!parcelIsInDelivery) return false;

  // user cannot return shipment if additional validation is not configured
  const { return: returnConfig, additionalIdReferencesBox } = config;
  const validationIsConfigured = !!additionalIdReferencesBox.fields.length;
  if (!validationIsConfigured) return false;

  // user cannot return shipment if return management is disabled
  return returnConfig.isEnabled;
};
